import { Route } from "@angular/router";
import { RegulamentoDetalhePage } from "./regulamento-detalhe.page";

export const RegulamentoDetalheRouter: Route[] = [
  { path: 'regulamento-detalhe', component: RegulamentoDetalhePage }
];
